module.exports = __webpack_public_path__ + "static/media/2.dcd2a8dd.png";